import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { FE_ADD_ORIGINATES_FROM_HEADER_250808 } from "@faire/retailer-settings/FE_ADD_ORIGINATES_FROM_HEADER_250808";


/**
 * Returns whether the browser tab ID header should be added to requests.
 * @returns true if the header should be added, false otherwise.
 */
export const getSettingAddOriginatesFromHeader = (): boolean =>
  getSettingValueWithoutAssignment(FE_ADD_ORIGINATES_FROM_HEADER_250808);